import { Obj } from "scrivito"
import { BuildingReferenceObjClass } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"
import { ProductAttributes } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantAttributes } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { ensureArray } from "shared/lib/arrayUtils"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"

export function useBuildingReferenceData({ id }: { id: string }) {
  const buildingRerenceObj = BuildingReferenceObjClass.onSite(
    getCurrentSiteID()
  ).get(id)

  const installationReferences = buildingRerenceObj?.children()

  const productsWithDuplicates = installationReferences
    ?.map(installationReference => {
      return (installationReference as InstallationReferenceObj).get("product")
    })
    .filter(Boolean) as
    | Obj<ProductAttributes | ProductBaseVariantAttributes>[]
    | undefined

  const productObjs = ensureArray(productsWithDuplicates).reduce(
    (acc, product) => {
      if (!acc.find(p => p.id() === product.id())) {
        acc.push(product)
      }
      return acc
    },
    [] as Obj<ProductAttributes | ProductBaseVariantAttributes>[]
  )

  const image = buildingRerenceObj?.get("imageWidgets")?.[0]

  return {
    buildingRerenceObj,
    productObjs,
    image
  }
}
